"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _reactRedux = require("react-redux");

var _reactRhumb = require("react-rhumb");

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UIRouterTab = _interopRequireDefault(require("ui-addon-react-router/UIRouterTab"));

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _LoadingHOC = _interopRequireDefault(require("settings-ui-lib/components/hoc/LoadingHOC"));

var _scopeChecks = require("settings-ui-lib/utils/scopeChecks");

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _RequestStatusTypes = require("settings-ui-sdk/constants/RequestStatusTypes");

var _selectors2 = require("settings-ui-sdk/Routes/selectors");

var _SettingsStickySaveFooter = _interopRequireDefault(require("settings-ui-lib/components/SettingsStickySaveFooter"));

var _stagingSelectors = require("../selectors/stagingSelectors");

var _StagingActions = require("../actions/StagingActions");

var _actions = require("settings-ui-sdk/AdsAccounts/actions");

var _selectors3 = require("settings-ui-sdk/AdsAccounts/selectors");

var _constants = require("../constants");

var _AdsEmptyState = _interopRequireDefault(require("../components/AdsEmptyState"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _interactionsSelectors = require("../selectors/interactionsSelectors");

var AdsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(AdsContainer, _PureComponent);

  function AdsContainer() {
    (0, _classCallCheck2.default)(this, AdsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AdsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(AdsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.fetchAdAccounts();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this = this;

      var usersToAutomaticallyDeauth = this.props.usersToAutomaticallyDeauth;

      if (prevProps.usersToAutomaticallyDeauth === usersToAutomaticallyDeauth || !usersToAutomaticallyDeauth.length) {
        return;
      }

      usersToAutomaticallyDeauth.map(function (user) {
        return _this.props.deleteUserAuth({
          network: user.network,
          networkUserId: user.networkUserId
        });
      });
    }
  }, {
    key: "enterAdsOnboarding",
    value: function enterAdsOnboarding() {
      window.location.href = "/ads/" + _hubspot.default.get() + "/onboarding-wizard";
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          activeTab = _this$props.activeTab,
          stagedChangesCount = _this$props.stagedChangesCount,
          saveRequestStatus = _this$props.saveRequestStatus,
          saveDisabled = _this$props.saveDisabled,
          fetchAdAccountsRequestStatus = _this$props.fetchAdAccountsRequestStatus,
          hasRoiReporting = _this$props.hasRoiReporting,
          accountsToList = _this$props.accountsToList,
          hasAdsWriteScope = _this$props.hasAdsWriteScope;
      var showZeroState = accountsToList.size === 0;
      return _react.default.createElement(_LoadingHOC.default, {
        requestStatuses: [fetchAdAccountsRequestStatus],
        unrecoverableFailure: true,
        successMarker: _react.default.createElement(_reactRhumb.NavMarker, {
          name: "ADS_ACCOUNTS_LOADED"
        }),
        failureMarker: _react.default.createElement(_reactRhumb.NavMarker, {
          name: "ADS_ACCOUNTS_LOADED_FAILURE"
        })
      }, showZeroState ? _react.default.createElement(_reactRhumb.NavMarker, {
        name: "ADS_ACCOUNTS_EMPTY_STATE_LOADED"
      }, _react.default.createElement(_AdsEmptyState.default, {
        onClick: this.enterAdsOnboarding,
        hasAdsWriteScope: hasAdsWriteScope
      })) : _react.default.createElement("div", null, _react.default.createElement(_UISubheader.default, {
        tabs: _react.default.createElement(_UITabs.default, {
          defaultSelected: 'adAccounts',
          use: "enclosed",
          selected: activeTab
        }, _react.default.createElement(_UIRouterTab.default, {
          tabId: "adAccounts",
          to: _constants.BASE_ADS_TAB_ROUTE + "/adAccounts",
          title: _react.default.createElement(_FormattedHTMLMessage.default, {
            message: "marketing.ads.tabs.accounts"
          })
        }), _react.default.createElement(_UIRouterTab.default, {
          tabId: "leadSyncing",
          to: _constants.BASE_ADS_TAB_ROUTE + "/leadSyncing",
          title: _react.default.createElement(_FormattedHTMLMessage.default, {
            message: "marketing.ads.tabs.leadSyncing"
          })
        }), _react.default.createElement(_UIRouterTab.default, {
          tabId: "pixels",
          to: _constants.BASE_ADS_TAB_ROUTE + "/pixels",
          title: _react.default.createElement(_FormattedHTMLMessage.default, {
            message: "marketing.ads.tabs.pixels"
          })
        }), hasRoiReporting && _react.default.createElement(_UIRouterTab.default, {
          tabId: "roiCalculation",
          to: _constants.BASE_ADS_TAB_ROUTE + "/roiCalculation",
          title: _react.default.createElement(_FormattedHTMLMessage.default, {
            message: "marketing.ads.tabs.roiCalculation"
          })
        })),
        title: _I18n.default.text('marketing.ads.pageTitle')
      }), children, _react.default.createElement(_SettingsStickySaveFooter.default, {
        description: _I18n.default.text('settingsui.pendingChanges', {
          count: stagedChangesCount
        }),
        shouldRender: stagedChangesCount !== 0,
        onCancel: this.props.clearStagedChanges,
        onSave: this.props.saveStagedChanges,
        saveRequestStatus: saveRequestStatus,
        saveDisabled: saveDisabled
      })));
    }
  }]);
  return AdsContainer;
}(_react.PureComponent);

AdsContainer.propTypes = {
  children: _propTypes.default.node.isRequired,
  activeTab: _propTypes.default.string.isRequired,
  hasRoiReporting: _propTypes.default.bool.isRequired,
  hasAdsWriteScope: _propTypes.default.bool.isRequired,
  saveRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  fetchAdAccountsRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  stagedChangesCount: _propTypes.default.number.isRequired,
  saveDisabled: _propTypes.default.bool.isRequired,
  clearStagedChanges: _propTypes.default.func.isRequired,
  saveStagedChanges: _propTypes.default.func.isRequired,
  fetchAdAccounts: _propTypes.default.func.isRequired,
  accountsToList: _propTypes.default.instanceOf(_immutable.List).isRequired,
  usersToAutomaticallyDeauth: _propTypes.default.array.isRequired,
  deleteUserAuth: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeTab: (0, _selectors2.getLastURLPathElement)(state),
    hasRoiReporting: (0, _selectors.getHasAdsRoiReporting)(state),
    hasAdsWriteScope: (0, _scopeChecks.matchesAllScopes)(['ads-write'])(state.auth.user),
    stagedChangesCount: (0, _stagingSelectors.getStagedChangesCount)(state),
    saveDisabled: (0, _stagingSelectors.hasErrors)(state),
    saveRequestStatus: (0, _stagingSelectors.getSaveStagedChangesRequestStatus)(state),
    fetchAdAccountsRequestStatus: (0, _selectors3.getFetchAdAccountsRequestStatus)(state),
    accountsToList: (0, _selectors3.getAdAccounts)(state),
    usersToAutomaticallyDeauth: (0, _interactionsSelectors.getUsersToAutomaticallyDeauth)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  clearStagedChanges: _StagingActions.clearStagedChanges,
  saveStagedChanges: _StagingActions.saveStagedChanges,
  fetchAdAccounts: _actions.fetchAdAccounts,
  deleteUserAuth: _actions.deleteUserAuth
})(AdsContainer);

exports.default = _default;
module.exports = exports.default;